/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const CaretDownIcon = createIcon(
  '0 0 20 20',
  <path d="M10 14 5 8h10z" />,
);
